import React, { useEffect, useState } from 'react';
import axios from 'axios';
// import * as signalR from '@microsoft/signalr';
// import { HubConnectionBuilder } from '@microsoft/signalr';
import './Chat.css';
import memberIcon from './../../images/chat-member-icon.svg';
import openListIcon from './../../images/type-on.svg';
import closeListIcon from './../../images/type-off.svg';
import sendIcon from './../../images/send.svg';
import userAvatar from './../../images/unkonowprofile.jpg';

const Chat = ({
    userLang,
    setIsShowNavigation,
    isShowNavigation,
    translations,
    isFullScreenMode,
}) => {
    // список всех чатов
    const [chatsList, setChatsList] = useState([]);

    // развернутый чат
    const [activeChat, setActiveChat] = useState(null);

    // введенное сообщение
    const [youMessage, setYouMessage] = useState(null);

    // сообщения в активном чате
    const [messages, setMessages] = useState([]);

    // интервал получения сообщений
    const [chatInterval, setChatInterval] = useState(null);

    // подключение SignalR
    const [connection, setConnection] = useState(null);

    useEffect(() => {
        const tg = window.Telegram.WebApp;

        if (activeChat) {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                handleCloseChat(activeChat);
            });
        }

        return () => {
            tg.BackButton.offClick(() => {
                handleCloseChat(activeChat);
            });
            tg.BackButton.hide();
        };
    }, [activeChat]);

    // запрос всех чатов при открытии копонента
    useEffect(() => {
        const handleChatsOpen = async () => {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/chats',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                            'Accept-Language': userLang,
                        },
                    }
                );
                if (response.data.success) {
                    console.log('Чаты: ', response.data.result);
                    setChatsList(response.data.result);
                }
            } catch (error) {
                console.error(
                    'Ошибка при получении списка активных чатов ',
                    error
                );
            }
        };
        handleChatsOpen();
    }, []);

    // форматирование даты
    const formatDate = (chatDate) => {
        const date = new Date(chatDate);
        const timeZoneOffset = new Date().getTimezoneOffset();
        const localDate = new Date(date.getTime() - timeZoneOffset * 60 * 1000);

        const day = localDate.getDate().toString().padStart(2, '0');
        const month = (localDate.getMonth() + 1).toString().padStart(2, '0');
        const hours = localDate.getHours().toString().padStart(2, '0');
        const minutes = localDate.getMinutes().toString().padStart(2, '0');

        return `${day}.${month} ${hours}:${minutes}`;
    };

    // запрос определенного чата при клике по нему
    const handleChatOpen = async (eventId) => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/chats/event/messages',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        eventId: eventId,
                    },
                }
            );
            if (response.data.success) {
                console.log('Чат открыт ', response.data);
                setMessages(response.data.result);

                const newChatInterval = setInterval(async () => {
                    try {
                        const response = await axios.get(
                            'https://mepointserver.ru/chats/event/messages',
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'authToken'
                                    )}`,
                                },
                                params: {
                                    eventId: eventId,
                                },
                            }
                        );
                        if (response.data.success) {
                            setMessages(response.data.result);
                        }
                    } catch (error) {
                        console.error('Ошибка получения сообщений ', error);
                    }
                }, 3000);

                setChatInterval(newChatInterval);
            }
        } catch (error) {
            console.error('Ошибка получения сообщений ', error);
        }
    };

    // развернуть чат
    const handleChatItemClick = (eventId) => {
        if (activeChat === null) {
            setIsShowNavigation(!isShowNavigation);
            setActiveChat(eventId);
            handleChatOpen(eventId);
        }
    };

    // свернуть чат
    const handleCloseChat = (eventId) => {
        if (activeChat === eventId) {
            setActiveChat(null);
            setIsShowNavigation(!isShowNavigation);
            setMessages([]);
            setYouMessage(null);
        }

        if (chatInterval) {
            clearInterval(chatInterval);
            setChatInterval(null);
        }
    };

    // отправить сообщение
    const handleSendMessage = async () => {
        try {
            const response = await axios.post(
                'https://mepointserver.ru/chats/event/message/send',
                {
                    eventId: activeChat,
                    message: youMessage,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );
            if (response.data.success) {
                console.log('Сообщение отправлено: ', response.data);
                setYouMessage(null);
            }
        } catch (error) {
            console.error('Ошибка при отправке сообщения ', error);
        }
    };

    return (
        <div className='chat__page'>
            <div
                className={
                    isFullScreenMode
                        ? 'chat__container_full'
                        : 'chat__container'
                }
            >
                <div
                    className={
                        isFullScreenMode ? 'chat__title_full' : 'chat__title'
                    }
                >
                    <h1>{translations.chats}</h1>
                </div>
                <div className={`chat__wrapper ${activeChat ? 'active' : ''}`}>
                    {chatsList.length <= 0 ? (
                        <p className='chat__no_messages'>
                            {translations.noActive}
                        </p>
                    ) : (
                        chatsList.map((chat) => (
                            <div
                                className={`chat__item ${
                                    chat.eventId === activeChat
                                        ? 'active'
                                        : activeChat
                                        ? 'off'
                                        : ''
                                }`}
                                key={chat.eventId}
                                onClick={() =>
                                    handleChatItemClick(chat.eventId)
                                }
                            >
                                <div
                                    className='chat__item_info'
                                    onClick={() =>
                                        handleCloseChat(chat.eventId)
                                    }
                                >
                                    <div className='chat__info'>
                                        <p className='chat__time'>
                                            {formatDate(chat.date)}
                                        </p>
                                        <h3 className='chat__subtitle'>
                                            {chat.name}
                                        </h3>
                                    </div>
                                    <div className='chat__info'>
                                        <img
                                            className='open__list_icon'
                                            src={
                                                chat.eventId === activeChat
                                                    ? closeListIcon
                                                    : openListIcon
                                            }
                                            alt='open'
                                        />
                                        <p className='members__count'>
                                            {chat.count}
                                        </p>
                                        <img
                                            className='members__chat_icon'
                                            src={memberIcon}
                                            alt='members'
                                        />
                                    </div>
                                </div>
                                <div className='chat__messages'>
                                    {messages.length > 0 &&
                                        messages
                                            .slice()
                                            .reverse()
                                            .map((message) =>
                                                message.isYouMessage ? (
                                                    <div
                                                        className='chat__you_messages'
                                                        key={message.messageId}
                                                    >
                                                        <div className='chat__you_time'>
                                                            <p>
                                                                {formatDate(
                                                                    message.date
                                                                )}
                                                            </p>
                                                        </div>
                                                        <p className='chat__you_message'>
                                                            {message.message}
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className='chat__another_messages'
                                                        key={message.messageId}
                                                    >
                                                        <div className='chat__another_photo'>
                                                            <img
                                                                src={
                                                                    message.userAvatar
                                                                        ? `https://mepointserver.ru${message.userAvatar}`
                                                                        : userAvatar
                                                                }
                                                                alt={
                                                                    message.userName
                                                                }
                                                            />
                                                        </div>
                                                        <div className='chat__another_message'>
                                                            <h3 className='chat__another_name'>
                                                                {
                                                                    message.userName
                                                                }
                                                            </h3>
                                                            <p className='chat__another_text'>
                                                                {
                                                                    message.message
                                                                }
                                                            </p>
                                                        </div>
                                                        <div className='chat__another_time'>
                                                            <p>
                                                                {formatDate(
                                                                    message.date
                                                                )}
                                                            </p>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                </div>
                                <div className='chat__send__message'>
                                    <input
                                        type='text'
                                        placeholder='Сообщение'
                                        className='chat__send_input'
                                        value={youMessage || ''}
                                        onChange={(e) =>
                                            setYouMessage(e.target.value)
                                        }
                                    />
                                    <button
                                        className='chat__button'
                                        onClick={handleSendMessage}
                                        disabled={!youMessage}
                                    >
                                        <img src={sendIcon} />
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default Chat;
